import AddParkingBay from "./addParkingbay";
import AllParkingBay from "./allParkingBay";
function ParkingbayMangement() {
  return <>
    <AddParkingBay />
    <AllParkingBay />
  </>
}

export default ParkingbayMangement